import { CaseSearchResultItem, ClientVersion } from '@acre/graphql'

import { RecentlyViewedCase } from '../../../pages/Cases/CaseDetails/CaseDetails.helpers'
import { DEFAULT_EMPTY_OPTION } from '../GlobalSearchOption/GlobalSearchOption'

const formatMultipleClientNameTag = (clients: ClientVersion[]) => {
  // Natural clients often have null value for is_natural_person field
  const company = clients.find((client) => client.details?.is_natural_person === false)

  if (company?.details?.organisation_name) {
    return company.details.organisation_name
  }

  return clients
    .map((client) => `${client.details.first_name || ''} ${client.details.last_name || ''}`.trim())
    .join(' + ')
}

export const formatCaseOption = (caseInput: RecentlyViewedCase) => {
  const { status, preference_mortgage_reason, owner_organisation, clients, address1, posttown, postcode } =
    caseInput || {}

  return {
    id: caseInput.id,
    doctype: 'client_case',
    overrideName: clients?.length ? formatMultipleClientNameTag(clients) : DEFAULT_EMPTY_OPTION,
    organisation_name: owner_organisation?.name,
    address: {
      address1: address1,
      post_town: posttown,
      postcode: postcode,
    },
    case_status: status,
    case_reason: preference_mortgage_reason,
  } as CaseSearchResultItem
}
